export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-folder-b585824fddc0d305e4c45523b9076880.svg";